import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../css/footer.css"; // Archivo CSS adicional para estilos personalizados

const Footer = () => {
  return (
    <footer className="footer text-light pt-5 pb-4">
      <div className="container">
        <div className="row">
          {/* Columna 1 - Logo*/}
          <div className="col-md-4 mb-4 text-center">
            <img 
              src="/images/logoblanco.png" 
              alt="Presencia Logo" 
              width="250" 
              className="mb-3"
            />
          </div>


          {/* Columna 2 - Contacto */}
          <div className="col-md-5 mb-4 text-center">
            <h5 className="fw-bold mb-3">Contáctanos</h5>
            <p className="mb-0">Sede administrativa</p>
            <p className="mb-0">Sector Prado Centro</p>
            <p className="mb-0">Medellín - Colombia</p>
            <p>Cra. 50 # 58-58</p>
            <p> +57 317 819 4087<br/>+57 316 428 9333</p>
          </div>


        {/* Columna 3 - Servicios */}
          <div className="col-md-3 mb-4">
            <h5 className="fw-bold mb-3">Nosotros</h5>
            <div className="social-icons mt-3">
                <a href="https://x.com/presenciacs" target="_blank" rel="noreferrer">
                    <i className="bi bi-twitter-x fs-3 me-3"></i>
                </a>
                <a href="https://web.facebook.com/people/Presencia-Colombo-Suiza/pfbid0HtWmo6tkt7PWWMzTAUwfVCQncJJcUbK3GQXNtVkjtnR8BTNjd4RJonqcMoD7ravdl/?mibextid=wwXIfr&rdid=ZgyTjDZQpJWrIgXd&share_url=https%3A%2F%2Fweb.facebook.com%2Fshare%2F1BEYQ5SijA%2F%3Fmibextid%3DwwXIfr%26_rdc%3D1%26_rdr" target="_blank" rel="noreferrer">
                    <i className="bi bi-facebook fs-3 me-3"></i>
                </a>
                <a href="https://www.youtube.com/channel/UCMCE4JeLGKThfHCyP5YokGQ" target="_blank" rel="noreferrer">
                    <i className="bi bi-youtube fs-3 me-3"></i>
                </a>
                <a href="https://www.instagram.com/presenciacs/#" target="_blank" rel="noreferrer">
                    <i className="bi bi-instagram fs-3 me-3"></i>
                </a>
            </div>
          </div>

        </div>

        <hr className="my-3" />
        <div className="text-center small">
          © 2025 Presencia Colombo-Suiza. Todos los derechos reservados


        </div>
      </div>
    </footer>
  );
};

export default Footer;
